import axios from "axios";
import { maintenanceInterceptor } from "./interceptors";
import { sanitizeInput } from "../sanitize";

// const MANAGEMENT_CONSOLE_BASE_URL = "http://10.10.72.16:6700";
// const USER_BASE_URL = "http://10.10.72.16:6701";
// const CMS_BASE_URL = "http://10.10.72.16:6705";

const MANAGEMENT_CONSOLE_BASE_URL = "https://partnerapi.synnex.com.au/";
const USER_BASE_URL = "https://partnerapi.synnex.com.au/";
const CMS_BASE_URL = "https://partnerapi.synnex.com.au/";

const api = axios.create({
  baseURL: MANAGEMENT_CONSOLE_BASE_URL,
});

const userApi = axios.create({
  baseURL: USER_BASE_URL,
});

// Orchid Core CMS Base URL
const cmsApi = axios.create({
  baseURL: CMS_BASE_URL,
});

// ---------------------------------------------------------------------------
// Request sanitizer — XSS defense-in-depth layer
// Recursively walks config.data (POST/PUT body) AND config.params (GET query
// params) and strips HTML tags from every string value using sanitizeInput().
// This covers:
//   - POST/PUT payloads (config.data) — e.g. support tickets, order notes
//   - GET query parameters (config.params) — e.g. Order History search, Ticket search
// ---------------------------------------------------------------------------
const sanitizePayload = (data) => {
  if (typeof data === "string") return sanitizeInput(data);
  if (Array.isArray(data)) return data.map(sanitizePayload);
  if (typeof data === "object" && data !== null) {
    return Object.fromEntries(
      Object.entries(data).map(([k, v]) => [k, sanitizePayload(v)])
    );
  }
  return data;
};

const requestSanitizer = (config) => {
  // Sanitize POST/PUT body (config.data)
  if (config.data && typeof config.data !== "string") {
    // config.data is already a parsed object (Axios default for JSON)
    config.data = sanitizePayload(config.data);
  } else if (typeof config.data === "string") {
    // config.data is a raw JSON string — parse, sanitize, re-stringify
    try {
      const parsed = JSON.parse(config.data);
      config.data = JSON.stringify(sanitizePayload(parsed));
    } catch {
      // Not JSON — leave as-is (e.g. FormData string)
    }
  }

  // Sanitize GET query parameters (config.params)
  // This covers Order History search, Ticket Details search, and any other
  // GET request that passes user input as query parameters.
  if (config.params && typeof config.params === "object") {
    config.params = sanitizePayload(config.params);
  }

  return config;
};

// Attach request sanitizer interceptor to all API instances.
api.interceptors.request.use(requestSanitizer);
userApi.interceptors.request.use(requestSanitizer);
cmsApi.interceptors.request.use(requestSanitizer);

// Attach maintenance interceptor to all API instances.
// On 503 + { status: "maintenance" }, dispatches a window CustomEvent so
// App.jsx can render the full-screen maintenance page.
api.interceptors.response.use(undefined, maintenanceInterceptor);
userApi.interceptors.response.use(undefined, maintenanceInterceptor);
cmsApi.interceptors.response.use(undefined, maintenanceInterceptor);

export { api, userApi, cmsApi };
